import SendIcon from '@mui/icons-material/Send';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import React, { useCallback, useState } from 'react';

import { UserRequestType } from '../../Types/enums';
import { CreateUserRequest } from '../../Types/userRequest';
import { useNotifications } from '../Providers/NotificationsProvider';

interface RequestCreditsModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (request: CreateUserRequest) => Promise<void>;
  userId: string | undefined;
}

export const RequestCreditsModal = ({
  open,
  onClose,
  onSubmit,
  userId,
}: RequestCreditsModalProps) => {
  const { refetchNotifications } = useNotifications();
  const [reason, setReason] = useState<string>('');

  const handleSubmit = useCallback(async () => {
    if (reason.trim()) {
      const request = {
        type: UserRequestType.DEEP_RESEARCH_CREDIT_REQUEST,
        reasonForRequest: reason.trim(),
        requesterId: userId,
      } as CreateUserRequest;

      await onSubmit(request);
      refetchNotifications();
      onClose();
    }
  }, [onSubmit, reason, onClose, userId, refetchNotifications]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Request Deep Research Credits</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <Typography variant="subtitle2" color="textSecondary">
            Reason for Request
          </Typography>
          <TextField
            multiline
            minRows={3}
            fullWidth
            variant="outlined"
            placeholder="Provide a reason for your credit request..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          endIcon={<SendIcon />}
          onClick={handleSubmit}
          disabled={!reason.trim()}
        >
          Submit Request
        </Button>
      </DialogActions>
    </Dialog>
  );
};
